import { render } from "./NuevoPlanModal.vue?vue&type=template&id=a60fda22&scoped=true"
import script from "./NuevoPlanModal.vue?vue&type=script&lang=js"
export * from "./NuevoPlanModal.vue?vue&type=script&lang=js"

import "./NuevoPlanModal.vue?vue&type=style&index=0&id=a60fda22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60fda22"]])

export default __exports__